// Code blocks of articles: the syntax colours come from highlight.js (highlightCode.js, a chunk of its own, only loaded
// when the page has a code block); the copy button works without it.
function initCodeCopy() {
    document.querySelectorAll('.article-code__copy').forEach((button) => {
        button.addEventListener('click', async () => {
            const code = button.closest('.article-code')?.querySelector('.article-code__pre code');
            if (!code) {
                return;
            }
            try {
                await navigator.clipboard.writeText(code.textContent);
            } catch (e) {
                return;
            }
            button.classList.add('is-copied');
            button.setAttribute('aria-label', button.dataset.copiedLabel || button.getAttribute('aria-label'));
            window.clearTimeout(button._copyResetTimeout);
            button._copyResetTimeout = window.setTimeout(() => {
                button.classList.remove('is-copied');
                button.setAttribute('aria-label', button.dataset.copyLabel || button.getAttribute('aria-label'));
            }, 2000);
        });
    });
}

export default function initHighlight() {
    const blocks = document.querySelectorAll('.article-code__pre code');
    if (blocks.length) {
        import(/* webpackChunkName: "highlight" */ './highlightCode').then(({default: highlightCode}) => highlightCode(blocks));
    }
    initCodeCopy();
}
